import { axios } from '@/utils/request'

const api = {

    getGoodsList: '/wyhadminapi/songpei/goodsList',
    deleteGoods: '/wyhadminapi/songpei/goodsDelete',
    setGoodsRank: '/wyhadminapi/songpei/setGoodsRank',
    setItemRank: '/wyhadminapi/songpei/setItemRank',
    editGoods: '/wyhadminapi/songpei/goodsEdit',
    addGoods: '/wyhadminapi/songpei/goodsAdd',
    getGoodsDetail: '/wyhadminapi/songpei/goodsDetail',
    getGoodsItemList: '/wyhadminapi/songpei/itemList',
    addItem: '/wyhadminapi/songpei/itemadd',
    editItem: '/wyhadminapi/songpei/itemedit',
    deleteItem: '/wyhadminapi/songpei/itemdelete',
    getItemDetail: '/wyhadminapi/songpei/itemDetail',


    applyList: '/wyhadminapi/songpei/applyList',
    applyDetail: '/wyhadminapi/songpei/applyDetail',
    editApply: '/wyhadminapi/songpei/editApply',
    applyDelete: '/wyhadminapi/songpei/applyDelete',


    saiquDetail: '/wyhadminapi/songpei/saiquDetail',
    editSaiqu: '/wyhadminapi/songpei/editSaiqu',
    addSaiqu: '/wyhadminapi/songpei/addSaiqu',
    saiquList: '/wyhadminapi/songpei/saiquList',


    saijiList: '/wyhadminapi/songpei/saijiList',
    saijiDetail: '/wyhadminapi/songpei/saijiDetail',
    editSaiji: '/wyhadminapi/songpei/editSaiji',
    sjsqOptions: '/wyhadminapi/songpei/sjsqOptions',

    saiquCashDetail: '/wyhadminapi/songpei/saiquCashDetail',
    setCash: '/wyhadminapi/songpei/setSaiquCash',

}

export default api


export function getApplyOrderDetail(parameter) {
    return axios({
        url: api.getApplyOrderDetail,
        method: 'post',
        data: parameter
    })
}
export function editApplyOrder(parameter) {
    return axios({
        url: api.editApplyOrder,
        method: 'post',
        data: parameter
    })
}
export function refreshOrder(parameter) {
    return axios({
        url: api.refreshOrder,
        method: 'post',
        data: parameter
    })
}

export function getGoodsList(parameter) {
    return axios({
        url: api.getGoodsList,
        method: 'post',
        data: parameter
    })
}
export function deleteGoods(parameter) {
    return axios({
        url: api.deleteGoods,
        method: 'post',
        data: parameter
    })
}
export function setGoodsRank(parameter) {
    return axios({
        url: api.setGoodsRank,
        method: 'post',
        data: parameter
    })
}
export function setItemRank(parameter) {
    return axios({
        url: api.setItemRank,
        method: 'post',
        data: parameter
    })
}
export function editGoods(parameter) {
    return axios({
        url: api.editGoods,
        method: 'post',
        data: parameter
    })
}
export function addGoods(parameter) {
    return axios({
        url: api.addGoods,
        method: 'post',
        data: parameter
    })
}
export function getGoodsDetail(parameter) {
    return axios({
        url: api.getGoodsDetail,
        method: 'post',
        data: parameter
    })
}
export function getGoodsItemList(parameter) {
    return axios({
        url: api.getGoodsItemList,
        method: 'post',
        data: parameter
    })
}
export function addItem(parameter) {
    return axios({
        url: api.addItem,
        method: 'post',
        data: parameter
    })
}
export function editItem(parameter) {
    return axios({
        url: api.editItem,
        method: 'post',
        data: parameter
    })
}
export function deleteItem(parameter) {
    return axios({
        url: api.deleteItem,
        method: 'post',
        data: parameter
    })
}
export function getItemDetail(parameter) {
    return axios({
        url: api.getItemDetail,
        method: 'post',
        data: parameter
    })
}
export function getApplyList(parameter) {
    return axios({
        url: api.applyList,
        method: 'post',
        data: parameter
    })
}
export function getApplyDetail(parameter) {
    return axios({
        url: api.applyDetail,
        method: 'post',
        data: parameter
    })
}
export function editApply(parameter) {
    return axios({
        url: api.editApply,
        method: 'post',
        data: parameter
    })
}



export function getSaijiList(parameter) {
    return axios({
        url: api.saijiList,
        method: 'get',
        params: parameter
    })
}

export function getSaijiDetail(parameter) {
    return axios({
        url: api.saijiDetail,
        method: 'get',
        params: parameter
    })
}

export function editSaiji(parameter) {
    return axios({
        url: api.editSaiji,
        method: 'post',
        data: parameter
    })
}



export function getSaiquList(parameter) {
    return axios({
        url: api.saiquList,
        method: 'get',
        params: parameter
    })
}



export function getSaiquDetail(parameter) {
    return axios({
        url: api.saiquDetail,
        method: 'get',
        params: parameter
    })
}

export function editSaiqu(parameter) {
    return axios({
        url: api.editSaiqu,
        method: 'post',
        data: parameter
    })
}


export function addSaiqu(parameter) {
    return axios({
        url: api.addSaiqu,
        method: 'post',
        data: parameter
    })
}


export function applyDelete(parameter) {
    return axios({
        url: api.applyDelete,
        method: 'post',
        data: parameter
    })
}



export function sjsqOptions(parameter) {
    return axios({
        url: api.sjsqOptions,
        method: 'post',
        params: parameter
    })
}

export function getSaiquCashDetail(parameter) {
    return axios({
        url: api.saiquCashDetail,
        method: 'get',
        params: parameter
    })
}

export function setSaiquCash(parameter) {
    return axios({
        url: api.setCash,
        method: 'post',
        data: parameter
    })
}
